import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './Header.module.css';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';

const Header = () => {
  const { user, logout, loading } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const { t, i18n: i18nInstance } = useTranslation('header');

  const handleLangToggle = () => {
    const next = i18nInstance.language === 'ja' ? 'en' : 'ja';
    i18n.changeLanguage(next);
    localStorage.setItem('language', next);
  };

  const handleLogoutLink = async (e) => {
    e.preventDefault();
    setMenuOpen(false);
    await logout();
    navigate('/login');
  };

  const handleMenuToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  const isSeller = ['organizer', 'artist', 'venue'].includes(user?.role);

  if (loading) return null;

  return (
    <header className={styles.header}>
      <div className={styles.logoContainer}>
        <Link to="/" className={styles.logoLink}>
          <img
            src="/icons/irietix.svg"
            alt={t('logoAlt')}
            className={styles.logoImage}
          />
        </Link>
      </div>
      <button className={styles.menuButton} onClick={handleMenuToggle} aria-label={t('menuAriaLabel')}>
        {menuOpen ? '×' : '≡'}
      </button>
      <nav className={`${styles.nav} ${menuOpen ? styles.open : ''}`}>
        {!isSeller && (
          <Link to="/seller-register" className={styles.sell} onClick={() => setMenuOpen(false)}>
            {t('sellTickets')}
          </Link>
        )}
        {user ? (
          <>
            {isSeller && (
              <Link to="/dashboard" className={styles.link} onClick={() => setMenuOpen(false)}>
                {t('dashboard')}
              </Link>
            )}
            <Link to="/profile/my" className={styles.link} onClick={() => setMenuOpen(false)}>
              {isSeller ? t('profile') : t('myPage')}
            </Link>
            <Link to="/settings/credentials" className={styles.link} onClick={() => setMenuOpen(false)}>
              {t('settings')}
            </Link>
            <Link to="/login" onClick={handleLogoutLink} className={styles.logout}>
              {t('logout')}
            </Link>
          </>
        ) : (
          <Link to="/login" className={styles.link} onClick={() => setMenuOpen(false)}>
            {t('login')}
          </Link>
        )}
        <button className={styles.langButton} onClick={handleLangToggle} aria-label="Switch language">
          {i18nInstance.language === 'ja' ? 'EN' : 'JA'}
        </button>
      </nav>
    </header>
  );
};


export default Header;
